import { put, select, takeEvery } from 'redux-saga/effects'
import { previousStep } from '../step-slice'
import { AllSteps, QuestionGroup, Scenario, ScenarioStep, Steps } from '../interfaces'
import { selectCurrentStep, selectNextSteps, selectScenario } from '../selectors'
import { clearAnswers } from '../answers-slice'
import { uniq } from 'lodash'

export function* stepSaga() {
  yield takeEvery(previousStep.type, steppedBack)
}

export function* steppedBack() {
  const currentStep: ScenarioStep = yield select(selectCurrentStep)
  const scenario: Scenario = yield select(selectScenario)
  const nextSteps: Steps[] = yield select(selectNextSteps)

  const stepsToClear: AllSteps[] = [...nextSteps]

  if (currentStep.group !== QuestionGroup.DEFAULT) {
    const stepsWithCurrentGroup = scenario.steps.filter((step) => step.group === currentStep.group)
    const currentStepIndex = stepsWithCurrentGroup.findIndex((step) => step.id === currentStep.id)
    stepsToClear.push(...stepsWithCurrentGroup.slice(currentStepIndex).map((step) => step.id))
  }

  yield put(clearAnswers({ ids: uniq(stepsToClear) }))
}
